export default {"src":"/_next/static/media/black-butterfly.a04432f5.svg","height":56,"width":80,"blurWidth":0,"blurHeight":0};